import React from "react";
import {
  Box,
  Typography,
  Avatar,
  Grid,
  Card,
  CardContent,
} from "@mui/material";
import { StarRate } from "@mui/icons-material";
import styled from "styled-components";

const testimonials = [
  {
    name: "Alice",
    feedback: "This AI app transformed my manuscript into a perfect audiobook.",
    occupation: "Author",
    avatar: "https://i.pravatar.cc/150?img=1",
  },
  {
    name: "Bob",
    feedback: "Incredible! The audio quality is superb. Highly recommended.",
    occupation: "Author",
    avatar: "https://i.pravatar.cc/150?img=8",
  },
  {
    name: "Charlie",
    feedback:
      "A game-changer for writers who need their books read fast and cheap.",
    occupation: "Author",
    avatar: "https://i.pravatar.cc/150?img=3",
  },
];

const TestimonialCard = styled.div`
  backdrop-filter: blur(5px);
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 10px;
  color: #fff;
  margin: 10px;
  padding: 20px;
  box-shadow: 0 4px 6px rgba(235, 225, 194, 0.7); // Added drop shadow with parchment cream color
`;

const Testimonials = () => {
  return (
    <Box
      padding={5}
      style={{ background: "rgba(0, 0, 0, 0.7)", color: "#fff" }}
    >
      <Typography
        variant="h4"
        gutterBottom
        textAlign="center"
        style={{ color: "#fff" }}
      >
        What Our Users Say
      </Typography>

      <Grid container spacing={3} justifyContent="center">
        {testimonials.map((testimonial, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <TestimonialCard>
              <CardContent>
                <Box display="flex" alignItems="center" marginBottom={2}>
                  <Avatar src={testimonial.avatar} alt={testimonial.name} />
                  <Box marginLeft={2}>
                    <Typography variant="subtitle1">
                      {testimonial.name}
                    </Typography>
                    <Typography variant="subtitle2" color="textSecondary">
                      {testimonial.occupation}
                    </Typography>
                  </Box>
                </Box>

                <Typography
                  variant="body2"
                  style={{ fontStyle: "italic", color: "#EBE1C2" }}
                >
                  "{testimonial.feedback}"
                </Typography>

                <Box display="flex" alignItems="center" marginTop={2}>
                  <StarRate style={{ color: "#EBE1C2" }} />
                  <StarRate style={{ color: "#EBE1C2" }} />
                  <StarRate style={{ color: "#EBE1C2" }} />
                  <StarRate style={{ color: "#EBE1C2" }} />
                  <StarRate style={{ color: "#EBE1C2" }} />
                </Box>
              </CardContent>
            </TestimonialCard>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Testimonials;
